import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import {
  FiInstagram,
  FiLinkedin,
  FiGithub,
  FiArrowUpRight
} from 'react-icons/fi';

import { FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  const navigate = useNavigate();
  const [clickCount, setClickCount] = useState(0);

  const handleNavClick = (to) => {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });

    navigate(to);
  };

  const handleCopyrightClick = () => {
    // Hidden admin trigger
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });

    navigate('/admin');
  };

  const services = [
    'Web Development',
    'Web App Development',
    'UI/UX Design',
    'Branding',
    'Software Development'
  ];

  const company = [
    { label: 'About Us', to: '/about' },
    { label: 'Projects', to: '/projects' },
    { label: 'Services', to: '/services' },
    { label: 'Contact', to: '/contact' },
  ];

  // Social Links
  const socials = [
    {
      icon: <FaWhatsapp />,
      href: 'https://wa.me/918838027168',
      label: 'WhatsApp'
    },
    {
      icon: <FiInstagram />,
      href: 'https://www.instagram.com/sitepixel.in',
      label: 'Instagram'
    },
    {
      icon: <FiLinkedin />,
      href: 'https://www.linkedin.com/in/vimal-popenzz-8aa808273/',
      label: 'LinkedIn'
    },
    {
      icon: <FiGithub />,
      href: 'https://github.com/vimalpopzz',
      label: 'GitHub'
    },
  ];

  return (
    <footer className="relative border-t border-white/5 mt-32">

      {/* Top Glow Line */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-px"
        style={{
          background:
            'linear-gradient(90deg, transparent, #7f049b, transparent)'
        }}
      />

      <div className="max-w-7xl mx-auto px-6 pt-20 pb-10">

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">

          {/* Brand */}
          <div className="md:col-span-2">

            <button
              onClick={() => handleNavClick('/')}
              className="flex items-center gap-4 mb-6 group"
            >

             

              {/* Brand Name */}
              <span className="font-display text-2xl font-medium tracking-widest text-white">
                 {/* Logo */}
              <img
                src="/Logo without BG.png"
                alt="SitePixel Logo"
                className="w-27 h-28 object-contain transition-transform duration-300 group-hover:scale-105"
              />
                
              </span>

            </button>

            {/* Description */}
            <p className="font-body text-white/45 text-sm leading-relaxed max-w-xs mb-8">
              We craft premium digital experiences that elevate brands and drive growth.
              From concept to deployment, we build with precision and artistry.
            </p>

            {/* Social Icons */}
            <div className="flex items-center gap-3">

              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-10 h-10 rounded-full flex items-center justify-center text-white/45 hover:text-white transition-all duration-250 border border-white/10 hover:border-purple-500/50 hover:bg-purple-500/10 hover:scale-105"
                >
                  {s.icon}
                </a>
              ))}

            </div>
          </div>

          {/* Services */}
          <div>

            <h4 className="font-body text-xs font-semibold tracking-widest uppercase text-white/30 mb-6">
              Services
            </h4>

            <ul className="space-y-3">

              {services.map((s) => (
                <li key={s}>

                  <button
                    onClick={() => handleNavClick('/services')}
                    className="font-body text-sm text-white/55 hover:text-white transition-colors duration-200 text-left"
                  >
                    {s}
                  </button>

                </li>
              ))}

            </ul>
          </div>

          {/* Company */}
          <div>

            <h4 className="font-body text-xs font-semibold tracking-widest uppercase text-white/30 mb-6">
              Company
            </h4>

            <ul className="space-y-3">

              {company.map((c) => (
                <li key={c.label}>

                  <button
                    onClick={() => handleNavClick(c.to)}
                    className="font-body text-sm text-white/55 hover:text-white transition-colors duration-200 text-left"
                  >
                    {c.label}
                  </button>

                </li>
              ))}

              <li>

                <a
                  href="mailto:thesitepixel@gmail.com"
                  className="font-body text-sm text-white/55 hover:text-white transition-colors duration-200"
                >
                  thesitepixel@gmail.com
                </a>

              </li>

            </ul>
          </div>
        </div>

        {/* CTA Banner */}
        <div className="glass-card p-8 md:p-12 mb-12 text-center relative overflow-hidden">

          <div
            className="glow-orb w-64 h-64 opacity-20 -top-20 left-1/2 -translate-x-1/2"
            style={{
              background: '#7f049b',
              animationDelay: '2s'
            }}
          />

          <p className="font-body text-xs tracking-widest uppercase text-purple-400 mb-3 font-semibold">
            Ready to build?
          </p>

          <h3 className="font-display text-4xl md:text-5xl font-normal text-white mb-6 leading-tight">
            Let's create something{' '}
            <em className="not-italic accent-text">
              extraordinary
            </em>
          </h3>

          <button
            onClick={() => handleNavClick('/contact')}
            className="btn-primary inline-flex items-center gap-2 text-base px-10 py-4"
          >
            Start a Project <FiArrowUpRight />
          </button>
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 border-t border-white/5">

          {/* Copyright */}
          <p
            className="font-body text-xs text-white/30 cursor-default select-none"
            onClick={handleCopyrightClick}
            title=""
          >
            © {new Date().getFullYear()} SitePixel.in. All rights reserved.
          </p>

          {/* Footer Links */}
          <div className="flex gap-6">

            <a
              href="#"
              className="font-body text-xs text-white/30 hover:text-white/60 transition-colors duration-200"
            >
              Privacy Policy
            </a>

            <a
              href="#"
              className="font-body text-xs text-white/30 hover:text-white/60 transition-colors duration-200"
            >
              Terms of Service
            </a>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;